import React from "react";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

export default function About() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const about = content.settings.about;

  return (
    <section id="about" className="bg-[#F7F2EA] py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">/ 01</span>
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">
            {about.eyebrow}
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#1A1A1A] leading-tight">
            {about.heading}
          </h2>
          <div>
            <p className="text-[#4A463F] text-base md:text-lg leading-relaxed font-light">
              {about.body}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-px bg-[#E4DBCB] mt-16 border border-[#E4DBCB]">
          {(about.highlights || []).map((h, i) => (
            <div key={i} className="bg-[#F7F2EA] p-8 text-center">
              <div className="font-serif-display text-2xl md:text-3xl text-[#C6A15B] mb-2">
                {h.value}
              </div>
              <div className="text-xs tracking-[0.14em] uppercase text-[#8A857A]">
                {h.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
